import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(
  () => ({
    wrapper: {
      position: 'fixed',
      zIndex: 99999,
      top: 0,
      overflow: 'visible',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
    },
    alert: {
      position: 'relative',
      overflow: 'hidden',
      padding: 'var(--ui-spacer-m)  var(--ui-spacer-l) var(--ui-spacer-m) var(--ui-spacer-m)',
      margin: '1rem',
      // minWidth: '16rem',
      minWidth: 'calc(100% - 2rem)',
      color: 'var(--ui-alert-default-text-color)',
      backgroundColor: 'var(--ui-alert-default-background-color)',
      borderColor: 'var(--ui-alert-default-border-color)',
      borderWidth: 'var(--ui-alert-default-border-width)',
      borderRadius: 'var(--ui-alert-default-border-radius)',
      borderStyle: 'solid',
    },
    alertError: {
      color: 'var(--ui-alert-error-text-color)',
      backgroundColor: 'var(--ui-alert-error-background-color)',
      borderColor: 'var(--ui-alert-error-border-color)',
      borderWidth: 'var(--ui-alert-error-border-width)',
      borderRadius: 'var(--ui-alert-error-border-radius)',
    },
    alertSuccess: {
      color: 'var(--ui-alert-success-text-color)',
      backgroundColor: 'var(--ui-alert-success-background-color)',
      borderColor: 'var(--ui-alert-success-border-color)',
      borderWidth: 'var(--ui-alert-success-border-width)',
      borderRadius: 'var(--ui-alert-success-border-radius)',
    },
    message: {
      fontSize: '1.6rem',
      fontWeight: 'normal',
      lineHeight: '1.6rem',
    },
    closeButton: {
      position: 'absolute',
      top: 0,
      right: 0,
      padding: 'var(--ui-spacer-m)',
      cursor: 'pointer',
      outline: 'none',
      '& img': {
        marginBottom: 0,
      },
    },
    cross: {
      margin: 0,
      display: 'block',
      '& path': {
        fill: 'currentColor',
      },
    },
  }),
)

export default useStyles
